import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BootstrapData } from '../../types/entities';

import { BootstrapDataState, initialState } from './state';

const bootstrapSlice = createSlice({
  name: 'bootstrap-data',
  initialState: initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: BootstrapDataState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    loaded: (state: BootstrapDataState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loaded = action.payload;
    },
    fail: (state: BootstrapDataState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
    },
    success: (state: BootstrapDataState, action: PayloadAction<BootstrapData>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.webApiVersion = action.payload.webApiVersion;
    }
  }
});

const { actions, reducer } = bootstrapSlice;
export const { reset, loading, loaded, success, fail } = actions;
export default reducer;
